var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative" },
    [
      _c(
        "div",
        {
          staticClass:
            "h-16 px-6 sticky top-18 z-20 bg-slate-300 border-b border-slate-400 flex flex-grow items-center justify-between gap-4",
          style: { minWidth: "calc(100vw - 22rem - 0.5rem)" }
        },
        [
          _c("div", { staticClass: "sticky top-18 left-94" }, [
            _c(
              "div",
              { staticClass: "flex items-center gap-4" },
              [
                _c("BlInputSearch", {
                  staticClass: "w-80",
                  attrs: { input: _vm.searchInput },
                  on: { changed: _vm.onInputSearch }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "w-40" },
                  [
                    _c("BlInputFilter", {
                      attrs: { input: _vm.filterInput },
                      on: { changed: _vm.onChangeFilter }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sticky top-18 right-6 flex items-center gap-2" },
            [
              _c(
                "router-link",
                { attrs: { to: "client-acquisition/edit" } },
                [
                  _c("BlInputButton", {
                    attrs: { type: "outlined", label: "Edit pipeline" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("BlInputButton", {
                attrs: { icon: "plus", label: "Prospect" },
                on: {
                  clicked: function($event) {
                    _vm.newProspectOpened = true
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.previewLoading
        ? _c("div", { staticClass: "w-full h-92 grid place-items-center" }, [
            _c("div", { staticClass: "blum-loader" })
          ])
        : !_vm.prospects || !_vm.prospects.length
        ? _c(
            "div",
            { staticClass: "grid place-items-center h-92" },
            [
              _vm.searchInput.model
                ? _c("BlTextBody2", {
                    staticClass: "lg:w-128 text-slate-700 text-center",
                    attrs: { text: "Oops, the prospect not found." }
                  })
                : _c("BlTextBody2", {
                    staticClass: "lg:w-128 text-slate-700 text-center",
                    attrs: { text: "Oops, there are no prospect available." }
                  })
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "mb-8 bg-slate-100" },
            [
              _c(
                "div",
                { staticClass: "py-4 px-6 flex" },
                [
                  _c("BlTextBody2", {
                    staticClass: "sticky left-94",
                    attrs: {
                      text: "Showing all " + _vm.totalProspects + " prospect(s)"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "sticky top-34 flex rounded-t bg-slate-100",
                  style: { zIndex: 11 },
                  attrs: { id: "appointment-header" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex pl-6 bg-slate-100 sticky left-88 z-10"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex border-t border-l border-r border-slate-400 rounded-tl"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "px-4 py-3 flex-shrink-0 bg-slate-200 w-20 rounded-tl"
                            },
                            [
                              _c("BlTextSubtitle3", {
                                staticClass: "text-slate-700",
                                attrs: { text: "ID" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "px-4 py-3 flex flex-shrink-0 bg-slate-200 w-60 rounded-tl"
                            },
                            [
                              _c("BlTextSubtitle3", {
                                staticClass: "text-slate-700",
                                attrs: { text: "Prospect name" }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-40"
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "text-slate-700",
                        attrs: { text: "Current stage" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-50"
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "text-slate-700",
                        attrs: { text: "Assigned to" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.enableBranch
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-50"
                        },
                        [
                          _c("BlTextSubtitle3", {
                            staticClass: "text-slate-700",
                            attrs: { text: "Branch" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-50"
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "text-slate-700",
                        attrs: { text: "Tags" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.stages, function(stage) {
                    return _c(
                      "div",
                      {
                        key: stage.id,
                        staticClass:
                          "px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-50 flex",
                        attrs: { title: "Date moved to " + stage.name }
                      },
                      [
                        _c("BlTextSubtitle3", {
                          staticClass: "text-slate-700 truncate",
                          attrs: { text: "Date moved to " + stage.name }
                        })
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-80 flex-grow"
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "text-slate-700",
                        attrs: { text: "Reason for discontinued" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(0)
                ],
                2
              ),
              _vm._v(" "),
              _vm._l(_vm.prospects, function(prospect, idx) {
                return _c("ProspectItem", {
                  key: prospect.id,
                  attrs: {
                    item: prospect,
                    isLast: idx + 1 === _vm.prospects.length
                  },
                  on: { "after-commit": _vm.fetchProspects }
                })
              })
            ],
            2
          ),
      _vm._v(" "),
      _vm.totalProspects > 25
        ? _c(
            "div",
            { staticClass: "flex" },
            [
              _c("BlInputPagination", {
                staticClass: "sticky left-94 my-6",
                style: { minWidth: "calc(100vw - 22rem - 3rem - 0.5rem)" },
                attrs: {
                  page: _vm.page,
                  perPage: _vm.perPage,
                  total: _vm.totalProspects
                },
                on: {
                  changed: _vm.changePage,
                  "changed-per-page": _vm.changePerPage
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.newProspectOpened
        ? _c("NewProspectModal", {
            on: {
              "close-modal": function($event) {
                _vm.newProspectOpened = false
              },
              "after-commit": _vm.fetchProspects
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex pr-6 bg-slate-100 sticky right-0 z-10" },
      [
        _c("div", {
          staticClass:
            "px-4 py-3 border-t border-r border-slate-400 rounded-tr flex-shrink-0 bg-slate-200 w-23"
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0aa25d65", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0aa25d65","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/prospects/Table.vue
// module id = null
// module chunks = 